/* global document */
'use strict';

import event from '../event';
import log from '../logger';

const types = {
    css: 'text/css',
    woff2: 'font/woff2'
};

export default function load(files, cb) {
    const links = document.querySelectorAll('link');
    const linksMap = {};

    for (let i = 0; i < links.length; i++) {
        const link = links[i];

        if (link.href) {
            linksMap[link.href] = true;
        }
    }

    // exclude any stylesheets already in the DOM (e.g. another fragment imported the same vendors)
    const filesToDownload = files.filter((file) => !linksMap[file.url]);
    // append all links to the DOM, but call cb() only for links with rel=stylesheet
    const totalCount = filesToDownload.filter((file) => isStylesheet(file)).length;
    let downloadCount = 0;
    let error;

    filesToDownload.forEach((file) => createLink(file, doCallback));

    if (totalCount === 0) {
        cb();
    }

    function doCallback(err, file) {
        downloadCount++;
        error = err || error;
        event.trigger(err ? 'error.file.link' : 'load.file.link', {error: err, file});

        if (downloadCount === totalCount) {
            cb(error);
        }
    }
}

function isStylesheet(file) {
    return !file.rel || file.rel === 'stylesheet';
}

function createLink(file, cb) {
    const link = document.createElement('link');

    if (isStylesheet(file)) {
        link.onerror = (err) => {
            cb(err, file);
        };
        link.onload = () => {
            let err;

            try {
                // IE/Edge do not fire onerror on <link> tags and throw exception when accessing cssRules if sheet is in error.
                if (link.sheet && link.sheet.cssRules) {
                    log.debug(`${file.url} cssRules`);
                }
            } catch (e) {
                err = true;
            }

            cb(err, file);
        };
    }

    // IE 9: append must be before href and href must be the last property set.
    // see https://stackoverflow.com/questions/1184950/dynamically-loading-css-stylesheet-doesnt-work-on-ie
    document.head.appendChild(link);

    if (types[file.type]) {
        link.type = types[file.type];
    }
    if (file.as) {
        link.as = file.as;
    }
    if (file.media) {
        link.media = file.media;
    }
    link.rel = file.rel || 'stylesheet';
    link.crossOrigin = 'anonymous';
    link.href = file.url;
}
